import { render } from "./OrderSideBar.vue?vue&type=template&id=25108fba&scoped=true"
import script from "./OrderSideBar.vue?vue&type=script&lang=js"
export * from "./OrderSideBar.vue?vue&type=script&lang=js"

import "./OrderSideBar.vue?vue&type=style&index=0&id=25108fba&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25108fba"]])

export default __exports__